import { useQuery } from 'react-query';
import { OrganizationAccount } from 'src/core/types';

import axios from './axios';

export function useOrganizationAccount() {
  return useQuery<OrganizationAccount>('organization-account', async () => {
    return axios
      .get<OrganizationAccount>(`/posht/ashena/organization/account/`)
      .then((res) => res.data);
  });
}
